<template>
  <div class="space-y-4 bg-white dark:bg-neutral-900 overflow-y-auto pb-8">
    <div
      class="bg-inherit sticky top-0 z-10 min-h-16 px-2 w-full gap-2 grid grid-cols-[1fr_auto_1fr] items-center"
    >
      <NamiButton
        class="mr-auto"
        @buttonClick="() => (menuOpen = false)"
        :icon="IconX"
        buttonType="secondary"
        text
        pill
      />
      <h2 class="font-medium text-lg">
        <slot name="header"></slot>
      </h2>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { IconX } from "@tabler/icons-vue";

const menuOpen = defineModel<boolean>({ default: false });
</script>
